import getThreadId from '@/lib/threads/getThreadId.js';
import getThreadProjectId from '@/lib/threads/getThreadProjectId.js';

const HOME_PROJECT_ID = 'project-home';

const buildThreadsByProject = ({ threads = [] } = {}) => {
  const nextByProject = {
    home: []
  };

  for (const thread of threads || []) {
    const threadId = getThreadId(thread);

    if (!threadId) {
      continue;
    }

    const projectId = getThreadProjectId(thread);
    const projectKey = !projectId || projectId === HOME_PROJECT_ID ? 'home' : projectId;

    if (!Array.isArray(nextByProject[projectKey])) {
      nextByProject[projectKey] = [];
    }

    nextByProject[projectKey].push(thread);
  }

  return nextByProject;
};

export default buildThreadsByProject;
